module.exports = __webpack_public_path__ + "static/Wellness0-4adc0e70a7a9d9cf89e2f8504abc34a6.png";